@if (conditionCount(); as conditionCountValue) {
  <pr-icon-chip
    #tooltipOrigin="cdkOverlayOrigin"
    cdkOverlayOrigin
    fontSet="material-symbols"
    icon="policy"
  >
    @if (conditionCountValue === 1) {
      1 condition
    } @else {
      {{ conditionCountValue }} conditions
    }
  </pr-icon-chip>

  <pt-custom-tooltip
    tooltipDelay="short"
    [target]="tooltipOrigin"
    [positions]="positions"
  >
    <ng-template ptCustomTooltipContent>
      <div class="flex max-w-xs flex-col gap-4 p-4">
        <pr-condition-logic-summary
          [scope]="scope()"
          [conditions]="conditions()"
        />
      </div>
    </ng-template>
  </pt-custom-tooltip>
}
